'use strict';

(function () {
  'use strict';

  angular.module('msTracker').directive('msAnimationCallback', msAnimationCallbackDir).component('trackerInputs', {
    bindings: {
      trackerObjects: '<',
      disableMessage: '<',
      trackerResults: '=',
      messageResult: '=',
      currentTracker: '&',
      onDone: '&'
    },
    templateUrl: 'tracker/templates/tracker-inputs.html',
    controller: MsTrackerCtrl
  });

  MsTrackerCtrl.$inject = ['$rootScope', '$state', '$timeout', 'NotifyingSvc', 'pageTitleSvc', '$translate', 'focus'];

  /* @ngInject */
  function MsTrackerCtrl($rootScope, $state, $timeout, NotifyingSvc, pageTitleSvc, $translate, focus) {
    $rootScope.$state = $state;
    var vm = this;

    vm.$onInit = function () {
      //wire up global event subscriber for page title changes
      pageTitleSvc.registerEventListeners();
      vm.direction = 'forward';
      // If there are any existing tracker values,
      // push them to vm.trackerResults now.
      // This would happen when editing a previous entry.
      vm.trackerObjects.forEach(function (tracker) {
        if (_.isNumber(tracker.value)) {
          vm.trackerResults.push({
            tracker: tracker,
            value: tracker.value
          });
        }
      });

      vm.numberOfTrackers = vm.trackerObjects.length;
      vm.goToTracker(0, 'forward');
    };

    // Focus on Tracker heading for correct screen reader announcing after animation
    vm.onAnimationEnd = function () {
      // Set 'move-animation' delay timeout to allow next / previous tracker to finish 'move' phase
      if (vm.trackerInFocusIndex === vm.trackerObjects.length && vm.trackerInFocusIndex !== 0) {
        focus.byId('personalNotesTitle', 400);
        return;
      }
      focus.byId('trackerModalTitle', 400);
    };

    // Focus on Tracker heading for correct screen reader announcing after first 'mood buttons' component init
    vm.onMoodButtonsLoaded = function (trackerIndex) {
      if (trackerIndex === 0 && !vm.trackerHasResult) {
        focus.byId('trackerModalTitle');
      }
    };

    vm.getSelectedValue = function (tracker) {
      var selectedTracker = vm.trackerResults.find(function (el) {
        return el.tracker.id === tracker.id;
      });
      return selectedTracker ? selectedTracker.value : null;
    };

    vm.onButtonCompUpdate = function (output) {
      vm.noAnswers = false;
      var entryIndex = _.findIndex(vm.trackerResults, matchTrackerId(output.tracker.id));
      // If this tracker already has an entry in this batch, overwrite it.
      if (entryIndex >= 0) {
        vm.trackerResults[entryIndex].value = output.value;
      }
      // Otherwise, create a new result.
      else {
          vm.trackerResults.push(output);
        }
      // If the message is disabled and the last tracker is in focus, don't do anything.
      // Otherwise, advance to the next tracker.
      if (!(vm.disableMessage && vm.trackerInFocusIndex === vm.numberOfTrackers - 1)) {
        $timeout(function () {
          vm.goToTracker(vm.trackerInFocusIndex + 1, 'forward');
        }, 0);
      }
    };

    vm.goToTracker = function (trackerIndex, direction) {
      vm.direction = direction;
      vm.trackerInFocusIndex = trackerIndex;
      vm.currentTracker = vm.trackerInFocusIndex;
      vm.trackerInFocus = vm.trackerObjects[vm.trackerInFocusIndex];
      if (vm.trackerInFocus !== undefined) {
        setPageTitle();
      }
      vm.trackerHasResult = vm.trackerResults[trackerIndex] !== undefined && vm.trackerResults[trackerIndex].value !== undefined;
      // True if the TrackerInFocusIndex the last Tracker, OR if the message box is disabled and TrackerInFocusIndex is one from the end (last step being the message box)
      vm.atLastTracker = vm.trackerInFocusIndex === vm.numberOfTrackers || (vm.disableMessage || vm.trackerResults.length === 0) && vm.trackerInFocusIndex === vm.numberOfTrackers - 1;
    };

    function setPageTitle() {
      $translate(['pageTitles.mood'], { mood: vm.trackerInFocus.title }).then(function (res) {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
          pageTitle: res['pageTitles.mood']
        });
      });
    }
  }

  function matchTrackerId(trackerIdToCompare) {
    return function (result) {
      return result.tracker.id === trackerIdToCompare;
    };
  }

  msAnimationCallbackDir.$inject = ['$animate'];

  /* @ngInject */
  function msAnimationCallbackDir($animate) {
    return {
      scope: {
        'msAnimationCallback': '&'
      },
      link: function link(scope, element) {
        $animate.on('leave', element, animationFinished);
        element.on('$destroy', function () {
          $animate.off('enter', element, animationFinished);
        });

        // Run callback after 'close' phase for 'leave' event
        function animationFinished(element, phase) {
          if (phase === 'close') {
            scope.msAnimationCallback();
          }
        }
      }
    };
  }
})();